import React from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer'

Font.register({
    family: 'Inter',
    fonts: [
        { src: `${process.env.PUBLIC_URL}/font/Inter-Regular.ttf` }
    ]
})

const styles = StyleSheet.create({
    scaleBarMarkers: {
        width: 1,
        height: 5,
    },
    scaleBarMarkersLast: {
        width: 1,
        height: 5,
    },
});

const initialValue = 0;
const endValue = 5;
const finalArray = [];

for (let n = initialValue; n <= endValue; n += 1) {
    finalArray.push({ label: n });
}

const ScaleBarQuinary = () => {

    return (
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {finalArray.map((item, index) => {

                const marginLeft =
                    index === 2 || index === 3 ? -3 :
                    index === 4 || index === 5 ? -4 :
                    -2;
                    
                return (
                    <View key={index} style={{ width: '20%' }}>
                        <View style={styles.scaleBarMarkers}></View>
                        <View>
                            <Text
                                style={{
                                    fontFamily: 'Inter',
                                    fontSize: 8,
                                    zIndex: 50,
                                    backgroundColor: '#fff',
                                    marginLeft,
                                }}
                            >{item.label}</Text>
                        </View>
                    </View>
                );
            })}
            <View>
                <View style={styles.scaleBarMarkersLast}></View>
                <View>
                    <Text style={{ fontSize: 8, marginLeft: -6 }}>6</Text>
                </View>
            </View>
        </View>
    )
}

export default ScaleBarQuinary